import React, { useState, useEffect } from 'react';
import { API } from '../../../api/URL_API';
import { Container, Row } from 'react-bootstrap';
import { ArrowRightCircleFill } from 'react-bootstrap-icons';
import { Card, CardContent, CardMedia, CardActionArea } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import Skeleton from '@mui/material/Skeleton';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import '../styles/PaginationDetalles.css';
import { useSucursal } from '../../../contexts/SucursalContext';
import { createSlug } from '../../../utils/slug';

// Función para obtener 4 categorías aleatorias
const getRandomCategories = (allCategories, count = 4) => {
    if (!allCategories || allCategories.length === 0) return [];
    const shuffled = [...allCategories].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
};

function CategoriasHome() {
    const [categorias, setCategorias] = useState([]);
    const [allCategorias, setAllCategorias] = useState([]);
    const { idSucursal } = useSucursal();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        fetch(`${API}/api/mostrarCategorias/categorias`)
            .then(response => response.json())
            .then(data => {
                // Extraer todas las categorías de todas las secciones
                const todasLasCategorias = data.flatMap(seccion => 
                    seccion.categorias ? seccion.categorias : []
                );
                setAllCategorias(todasLasCategorias);
                setCategorias(getRandomCategories(todasLasCategorias, 4));
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar las categorias', error);
                setIsLoading(false);
            });
    }, []);

    // Cambiar categorías cada 30 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            if (allCategorias.length > 0) {
                setCategorias(getRandomCategories(allCategorias, 4));
            }
        }, 30000); // 30 segundos

        return () => clearInterval(interval);
    }, [allCategorias]);

    const handleMoreCollection = () => {
        if (idSucursal) {
            navigate(`/${idSucursal}/Catalogo`);
        } else {
            console.error('idSucursal no disponible');
        }
    };

    return (
        <Container fluid>
            <Row className='mb-2'>
                <div className='d-flex align-items-center justify-content-between w-100'>
                    <h4 className='ms-2 text1-cr fw-bold fst-italic'>Colecciones ✨</h4>
                    <button className='button-cr fst-italic' onClick={handleMoreCollection}>
                        Ver más <ArrowRightCircleFill size={18} className='text-light ms-2' />
                    </button>
                </div>
            </Row>
            <Swiper
                slidesPerView={4}
                spaceBetween={20}
                loop={true} // Activa el loop
                pagination={{
                    clickable: true,
                    dynamicBullets: true // Activa los bullets dinámicos
                }}
                autoplay={{ delay: 5000 }}
                modules={[Pagination, Autoplay]}
                breakpoints={{
                    0: { slidesPerView: 1.2 },
                    480: { slidesPerView: 1.5 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 }
                }}
                className="mySwiper"
            >
                {isLoading
                    ? Array.from({ length: 4 }).map((_, idx) => (
                        <SwiperSlide key={idx} className="d-flex h-100 mb-5">
                            <Card
                                className='product-card mt-2 mx-2 h-100 w-100'
                                style={{
                                    boxShadow: '0 4px 8px rgba(43, 35, 94, 0.3), 0 6px 20px rgba(43, 35, 94, 0.3)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    width: '100%',
                                }}
                            >
                                <CardActionArea>
                                    <Skeleton variant="rectangular" height={300} width="100%" animation="wave" />
                                    <CardContent className='text-center text1-cr'>
                                        <Skeleton variant="text" width="80%" height={30} />
                                        <Skeleton variant="text" width="60%" height={25} />
                                        <Skeleton variant="text" width="50%" height={20} />
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </SwiperSlide>
                    ))
                    : categorias.map((categoria, idx) => (
                        <SwiperSlide key={idx} className="d-flex my-3">
                            <Card
                                className='mt-2 mx-2 h-100 w-100'
                                style={{
                                    boxShadow: '0 4px 8px rgba(43, 35, 94, 0.3), 0 6px 20px rgba(43, 35, 94, 0.3)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                     transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                     cursor: 'pointer',
                                     backgroundColor: '#fff',
                                     width: '100%',
                                }}
                            >
                                <Link
                                    to={`/${idSucursal}/Productos/${createSlug(categoria.nomCategoria)}`}
                                    className="text-decoration-none d-flex flex-column"
                                >
                                    <CardMedia
                                        component='img'
                                        height='300'
                                        image={`${categoria.imgCategoria}`}
                                        alt={`ver ${categoria.nomCategoria}`}
                                        title={`crisha-${categoria.nomCategoria}`}
                                        className='card-media-image'
                                        style={{
                                            aspectRatio: '1/1',
                                            objectFit: 'cover',
                                            height: '100%'
                                        }}
                                    />
                                    <CardContent className='text-center text1-cr'>
                                        <h4 className='fw-bold'>{categoria.nomCategoria}</h4>
                                    </CardContent>
                                </Link>
                            </Card>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </Container>
    );
}

export default CategoriasHome;
